/* unplugin-vue-components disabled */import { render } from "./UserSign.vue?vue&type=template&id=aebfa19a&scoped=true"
import script from "./UserSign.vue?vue&type=script&lang=js"
export * from "./UserSign.vue?vue&type=script&lang=js"

import "./UserSign.vue?vue&type=style&index=0&id=aebfa19a&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebfa19a"]])

export default __exports__